export enum UserRoles {
    User = 'User',
    Admin = 'Admin',
    Owner = 'Owner',
}
